module.exports = __webpack_public_path__ + "img/01-green.e431a14b.svg";